// extracted by mini-css-extract-plugin
export default {"moduleHead":"index_moduleHead_HIx0i","title":"index_title_ndYnp","subTitle":"index_subTitle_NDV82","more":"index_more_dtEKi"};